import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=47a6b8f1&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=js&"
export * from "./page-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6b8f1",
  null
  
)

export default component.exports